import React, { useState } from "react";
import { cn } from "src/lib/utils";

const PasswordInput = ({ label, name, className, placeholder, value, onChange, error, autoComplete }) => {
	const [showPassword, setShowPassword] = useState(false);

	const togglePasswordVisibility = () => {
		setShowPassword((prev) => !prev);
	};

	return (
		<div className={cn("formItem", className)}>
			<label htmlFor={name}>{label}</label>

			<div className="passwordWrapper">
				<input
					id={name}
					name={name}
					type={showPassword ? "text" : "password"}
					placeholder={placeholder}
					value={value}
					onChange={onChange}
					autoComplete={autoComplete}
					className={error ? "inputError" : ""}
				/>
				<button type="button" className="togglePassword" onClick={togglePasswordVisibility}>
					{showPassword ? "🙈" : "👁️"}
				</button>
			</div>
			{error && <p className="errorMsg">{error}</p>}
		</div>
	);
};

export default PasswordInput;
